import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { SITE } from '../mock';

export const CopyCode = ({ testId = 'copy-code-btn', className = '' }) => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(SITE.code); } catch (e) { window.prompt('Copy the code:', SITE.code); }
    setCopied(true);
    setTimeout(() => setCopied(false), 1800);
  };
  return (
    <>
      <button type="button" onClick={copy} data-testid={testId} aria-label={copied ? 'Code copied' : `Copy referral code ${SITE.code}`}
        className={`inline-flex items-center gap-1.5 text-xs font-display font-bold text-cyan border border-[var(--ar-border-cyan)] rounded-lg px-3 py-2 min-h-[36px] hover:bg-[rgba(0,217,255,0.12)] transition-colors ${className}`}>
        {copied ? <><Check size={14} aria-hidden="true" /> COPIED</> : <><Copy size={14} aria-hidden="true" /> COPY</>}
      </button>
      <span className="sr-only" role="status" aria-live="polite">{copied ? 'Code ASIANRISK copied to clipboard' : ''}</span>
    </>
  );
};
